import { useLiveQuery } from 'dexie-react-hooks';
import { useCallback, useEffect, useState } from 'react';
import { fetchTrip } from '../lib/api';
import { db } from '../lib/db';

/** Detalhe de uma viagem: cache local + gastos pendentes de sincronização daquela viagem. */
export function useTrip(tripId: string | undefined) {
  const trip = useLiveQuery(() => (tripId ? db.trips.get(tripId) : undefined), [tripId]);
  const pending = useLiveQuery(
    () => (tripId ? db.pendingExpenses.where('tripId').equals(tripId).sortBy('createdAt') : []),
    [tripId],
  );
  const [error, setError] = useState<string>();
  const [refreshing, setRefreshing] = useState(false);

  const refresh = useCallback(async () => {
    if (!tripId) return;
    setRefreshing(true);
    setError(undefined);
    try {
      const fresh = await fetchTrip(tripId);
      await db.trips.put({ ...fresh, cachedAt: Date.now() });
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Não foi possível atualizar a viagem');
    } finally {
      setRefreshing(false);
    }
  }, [tripId]);

  useEffect(() => {
    void refresh();
  }, [refresh]);

  return {
    trip,
    loading: trip === undefined,
    pending: pending ?? [],
    refreshing,
    error,
    refresh,
  };
}
